export default (element: Element, styleName: string, asInteger = true) => {
    const style = getComputedStyle(element)

    if (asInteger) {
        return parseInt(style.getPropertyValue(styleName), 10)
    }

    return style.getPropertyValue(styleName)
}
